module.exports = __webpack_public_path__ + "media/customizations/sienna/logo-2fdd0312e89a352df158bdb4a2ae2840.png";